export default __webpack_public_path__ + "static/media/visa-card.eb3edf92.svg";